import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostBinding, Input,
  OnDestroy, OnInit, Output, ViewEncapsulation
} from '@angular/core';

import type { IPushBanner } from './push-banner.interface';

import {
  BrandsEnum, BrandThemesEnum, DeviceService, IconSizeEnum, PositionEnum, SdBannerComponent, SdHtmlComponent, SdIconComponent,
  SdLinkComponent, SdTagComponent, SdThemeComponent, SdTitleComponent, SdTooltipComponent, ThemesEnum
} from '@seb/web-design-system/core';

@Component({
  selector: 'sd-push-banner',
  templateUrl: './push-banner.component.html',
  styleUrls: ['./push-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    SdTagComponent,
    SdTitleComponent,
    SdIconComponent,
    SdTooltipComponent,
    SdLinkComponent,
    SdBannerComponent,
    SdHtmlComponent,
    TranslateModule
  ]
})
export class SdPushBannerComponent extends SdThemeComponent implements OnInit, OnDestroy {
  /**
   * Allow to define either the theme is dark or light (default)
   * * @param {string} dark | light | brand | & marketing
   */
  @Input()
  themesConfig: ThemesEnum | BrandThemesEnum.brand;

  @Input()
  pushBannerData: IPushBanner;

  @Input()
  titleLevel: number;

  @Input()
  twicPicsAutoSize = true;

  @Input()
  isCopyTag = false;

  @Input()
  class = ''; // override the standard class attr with a new one.
  @HostBinding('class')
  get hostClasses(): string {
    return [
      'c__push-card',
      this.class,
      this.pushBannerData.media ? 'has-background' : '',
      this.themesConfig ? 'is-theme-' + this.themesConfig : '',
      this.brand === BrandsEnum.krups ? 'text-color-invert' : ''
    ]
      .filter(Boolean)
      .join(' ');
  }

  @Output()
  clickPromoLink = new EventEmitter<string>();

  @Output()
  public copied: EventEmitter<string> = new EventEmitter<string>();

  buttonTheme: ThemesEnum;
  isDevice$: boolean;
  subscriptions = new Subscription();
  isMobile$: boolean;
  themesEnum = ThemesEnum;
  positionEnum = PositionEnum;
  iconSize = IconSizeEnum;

  constructor(
    private cdRef: ChangeDetectorRef,
    private deviceService: DeviceService
  ) {
    super();
  }

  ngOnInit() {
    this.subscriptions.add(
      this.deviceService.isMobile.subscribe((x) => {
        this.isMobile$ = x;
        this.cdRef.markForCheck();
      })
    );

    this.subscriptions.add(
      this.deviceService.isDevice.subscribe((x) => {
        this.isDevice$ = x;
        this.cdRef.markForCheck();
      })
    );

    this.manageThemesButtons(this.themesConfig);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  manageThemesButtons(theme: ThemesEnum | BrandThemesEnum) {
    switch (theme) {
      case ThemesEnum.dark:
        this.buttonTheme = ThemesEnum.default;
        break;
      case ThemesEnum.light:
        this.buttonTheme = ThemesEnum.default;
        break;
      case ThemesEnum.promo:
        this.buttonTheme = ThemesEnum.invert;
        break;
      case ThemesEnum.promo2:
        this.buttonTheme = ThemesEnum.invert;
        break;
      case ThemesEnum.extra:
        this.buttonTheme = ThemesEnum.invert;
        break;
      case ThemesEnum.stars:
        this.buttonTheme = ThemesEnum.invert;
        break;
      case BrandThemesEnum.brand:
        this.buttonTheme = ThemesEnum.invert;
        break;
    }
  }

  onClickPromoLink(url: string) {
    this.clickPromoLink.emit(url);
  }

  onCopied(event: string) {
    this.copied.emit(event);
  }
}
